import React from 'react';

import { Children, Element } from 'interfaces';

import {
  Wrapper
} from './Title.styles';

export interface TitleProps {
  children: Children;
  className?: string;
  size?: 'big' | 'normal' | 'small';
  color?: 'black' | 'white' | 'primary' | 'secondary' | 'trinary';
  noMargin?: boolean;
  element?: Element;
}

const Title = ({ children, size = 'normal', color = 'primary', className = '', noMargin = false, element = 'h1' }: TitleProps) => {
  return (
    <Wrapper as={element} size={size} color={color} noMargin={noMargin} className={className}>
      {children}
    </Wrapper>
  );
};

export default Title;
